<template>
    <v-menu dark offset-y tile attach=".v-app-bar">
        <template #activator="{ on, attrs }">
            <v-btn v-on="on" plain outlined class="px-2" height="40">
                <v-icon small class="mr-2">mdi-hexagon-multiple</v-icon>
                <template v-if="$vuetify.breakpoint.smAndUp">
                    <span class="project-name">
                        <template v-if="project">{{project.name}}</template>
                        <template v-else>choose a project</template>
                    </span>
                    <v-icon small class="ml-2">
                        mdi-chevron-{{attrs['aria-expanded'] === 'true' ? 'up' : 'down'}}
                    </v-icon>
                </template>
            </v-btn>
        </template>
        <v-list dense>
            <v-list-item v-for="p in projects" :key="p.Name" :to="{name: 'project', params: {projectId: p.id}}">
                {{p.name}}
            </v-list-item>
            <v-list-item :to="{name: 'workspace_settings'}" exact>
                <v-icon small>mdi-plus</v-icon> new project
            </v-list-item>
        </v-list>
    </v-menu>
</template>

<script>
export default {
    props: {
        projects: Array,
    },

    computed: {
        project() {
            const id = this.$route.params.projectId;
            return (this.projects || []).find(p => p.id === id);
        },
    },
}
</script>

<style scoped>

</style>